
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstationcabs() {



    const cardData =
    {
        keyword: 'Pune Outstation Cabs',
        heading: 'Platinum24 Cabs: Pune Outstation Cabs',
        headingDescription: ' Platinum24 Cabs provides dependable Pune Outstation Cabs, perfect for family vacations, corporate travel, weekend getaways, and long-distance journeys. With a wide range of hatchbacks, sedans, SUVs, and luxury cars, we ensure maximum comfort and reliability on highways and hilly routes. Our experienced chauffeurs, punctual pickups, and flexible one-way or round-trip options make outstation travel smooth and stress-free. Whether you’re heading to Mumbai, Mahabaleshwar, Shirdi, Goa, or anywhere across Maharashtra and beyond, Platinum24 Cabs guarantees affordable fares, clean vehicles, and a safe, enjoyable travel experience every time.',

        top: 'Top Places to Visit in Pune Outstation with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located 120 km from Pune, is a lush hill station known for its viewpoints, strawberry farms, and temples. Venna Lake offers boating and horse rides, while Arthur’s Seat and Wilson Point provide panoramic views of valleys. Mapro Garden is famous for fresh strawberry cream and jams. Monsoon adds mist and waterfalls, making it magical. The Mahabaleshwar Temple adds spiritual significance. It is Pune’s favorite weekend hill getaway."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are twin hill stations loved for their waterfalls, caves, and forts. Bhushi Dam, Tiger’s Leap, and Karla Caves are major attractions. Pawna Lake offers camping and stargazing experiences. Trekkers explore Lohagad and Rajmachi Fort for history and adventure. The region is also famous for chikki sweets. Lonavala–Khandala is Pune’s closest and most popular weekend escape."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, about 200 km from Pune, is the holy town of Shri Sai Baba. The Samadhi Mandir, Dwarkamai, Chavadi, and Gurusthan are the main pilgrimage sites. Devotees from across India visit for darshan and aarti rituals. The town also offers spiritual museums and heritage parks. Nearby Shani Shingnapur is another sacred spot. Shirdi is Pune’s divine outstation pilgrimage destination."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, around 110 km from Pune, is one of the 12 Jyotirlinga shrines of Lord Shiva. Surrounded by dense forests, it is also a wildlife sanctuary home to the giant Indian squirrel. Pilgrims trek to Gupt Bhimashankar and visit Hanuman Lake. Trekkers enjoy misty trails, waterfalls, and scenic valleys in monsoon. It is both a spiritual and adventure spot. Bhimashankar is Pune’s divine and natural retreat."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, 140 km from Pune, is a coastal town known as the ‘Goa of Maharashtra.’ Clean beaches like Alibaug, Kashid, and Nagaon attract weekend travelers. Kolaba Fort and temples add cultural value. Water sports, beach resorts, and seafood complete the holiday experience. Ferries from Mumbai add charm for round trips. Alibaug is Pune’s coastal paradise of fun and relaxation."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, about 60 km from Pune, is a planned hill city inspired by Italian architecture. Located on the banks of Warasgaon Lake, it offers boating, kayaking, and lakeside dining. The colorful buildings and waterfront promenades make it Instagram-worthy. Monsoon makes it misty and romantic. Resorts and adventure sports attract families and couples. Lavasa is Pune’s modern outstation holiday retreat."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a blend of spirituality and wine tourism. It is home to Trimbakeshwar Jyotirlinga, Kalaram Temple, and Panchavati, connected with Lord Rama. The Godavari ghats and Ramkund hold religious significance. Sula Vineyards offer wine tours, tastings, and festivals. Nashik also hosts the grand Kumbh Mela. It is Pune’s mix of devotion, history, and modern leisure."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, 230 km from Pune, is famous for the Mahalaxmi Temple, one of the Shakti Peethas. The city is also known for Rankala Lake, New Palace Museum, and Panhala Fort. Shoppers enjoy Kolhapuri chappals, jewelry, and spicy cuisine. The city combines heritage, culture, and food in one package. Pilgrims and tourists alike flock here year-round. Kolhapur is Pune’s cultural and spiritual getaway."
  },
  {
    "title": "Matheran",
    "description": "Matheran, 120 km from Pune, is India’s only automobile-free hill station. It offers horse rides, toy train rides, and lush viewpoints like Panorama Point and Louisa Point. Dense forests and red soil pathways give it a rustic charm. In monsoon, the waterfalls and mist make it enchanting. Eco-tourism lovers find it ideal for peace and trekking. Matheran is Pune’s serene eco-hill retreat."
  },
  {
    "title": "Goa",
    "description": "Goa, around 450 km from Pune, is India’s ultimate beach paradise. Famous for Baga, Calangute, and Anjuna beaches, it offers nightlife, water sports, and flea markets. Old Goa churches like Basilica of Bom Jesus are UNESCO heritage sites. Dudhsagar Waterfall and spice plantations add nature’s touch. Goa offers everything from party vibes to quiet retreats. It is Pune’s long-weekend coastal escape."
  }
],



"services": [
    {
      "name": "Pune Outstation Cab Services",
      "description": "Trusted outstation cab services from Pune providing comfortable and safe travel options for long-distance journeys. Our fleet includes a variety of vehicles suited for solo travelers, families, and groups, with professional drivers ensuring a smooth and timely trip."
    },
    {
      "name": "Pune Outstation Taxi Booking",
      "description": "Hassle-free online booking for outstation taxis from Pune, offering quick confirmation, transparent pricing, and multiple payment options. Plan your outstation trips effortlessly with our reliable taxi service."
    },
    {
      "name": "Pune Outstation Car Rental",
      "description": "Wide selection of car rental options for outstation travel from Pune, ranging from economy to luxury cars. Choose from self-drive or chauffeur-driven vehicles tailored to your itinerary and preferences."
    },
    {
      "name": "Pune Outstation Chauffeur-Driven Cabs",
      "description": "Premium chauffeur-driven cabs for outstation trips starting from Pune, combining luxury, comfort, and expert driving to deliver a first-class travel experience across your chosen destinations."
    },
    {
      "name": "Pune Outstation One-Way Taxi",
      "description": "Flexible and affordable one-way taxi services for outstation travel from Pune, ideal for travelers looking for point-to-point transport without round-trip commitments."
    },
    {
      "name": "Pune Outstation Round Trip Cabs",
      "description": "Convenient round trip cab services from Pune for outstation destinations, perfect for tourists and corporate travelers wanting seamless travel with guaranteed return pickups."
    },
    {
      "name": "Pune Outstation Luxury Taxi",
      "description": "Travel in elegance with our luxury outstation taxi services from Pune featuring premium vehicles equipped with all modern amenities for a comfortable and stylish journey."
    },
    {
      "name": "Pune Outstation Self-Drive Car Rental",
      "description": "Enjoy the freedom to explore with self-drive car rentals for outstation trips from Pune. Our fleet includes well-maintained vehicles that provide flexibility and privacy for your travels."
    },
    {
      "name": "Pune Outstation Travel Packages",
      "description": "Comprehensive outstation travel packages from Pune, including transportation, tolls, driver allowances, and optional sightseeing tours. Perfect for group tours, family vacations, and corporate outings."
    },
    {
      "name": "Pune Outstation Private Car Hire",
      "description": "Private car hire services for outstation travel from Pune, offering customized itineraries and personalized service for a hassle-free and comfortable journey."
    },
    {
      "name": "Pune Outstation Cabs",
      "description": "Reliable and efficient outstation cab services from Pune with a fleet of vehicles that cater to different group sizes and budgets, ensuring safe and pleasant journeys."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Professional outstation taxi service based in Pune, focusing on safety, punctuality, and customer satisfaction for all types of long-distance travel."
    },
    {
      "name": "One Way Cab Pune",
      "description": "Affordable and flexible one-way cab options from Pune for outstation trips, ideal for travelers with one-directional travel needs."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Highly rated outstation cab service in Pune known for excellent customer service, reliable vehicles, and expert drivers catering to all your travel needs."
    },
    {
      "name": "Outstation Cab Service in Pune",
      "description": "Trusted outstation cab services from Pune offering seamless travel experiences with well-maintained cars and professional chauffeurs."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Extensive outstation car rental options available in Pune including both self-drive and chauffeur-driven vehicles suited for various travel plans."
    },
    {
      "name": "Taxi in Pune for Outstation",
      "description": "Dependable taxi services in Pune specializing in outstation travel, ensuring comfortable rides and timely arrivals across all major destinations."
    },
    {
      "name": "Taxi Service in Pune for Outstation",
      "description": "Efficient taxi service from Pune for outstation journeys with well-maintained fleet and experienced drivers dedicated to customer satisfaction."
    },
    {
      "name": "Book Outstation Cabs Pune",
      "description": "Easy online platform to book outstation cabs from Pune with instant confirmation and transparent pricing for stress-free travel planning."
    },
    {
      "name": "Cab Booking in Pune for Outstation",
      "description": "Convenient cab booking services in Pune for outstation trips, providing a wide range of vehicles to suit solo travelers and groups alike."
    },
    {
      "name": "Outstation Taxi in Pune",
      "description": "Reliable outstation taxi services in Pune focusing on safety, punctuality, and customer comfort for long-distance travel."
    },
    {
      "name": "Outstation Taxi Service in Pune",
      "description": "Professional and affordable outstation taxi services based in Pune, ideal for personal, family, and corporate travel needs."
    },
    {
      "name": "Pune Airport to Kolhapur cab",
      "description": "Specialized cab services from Pune Airport to Kolhapur, ensuring a smooth and comfortable journey with experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Pune Car Rental Outstation",
      "description": "Comprehensive car rental services from Pune for outstation travel, including self-drive and chauffeur-driven options tailored to your itinerary."
    },
    {
      "name": "Pune to Gokarna Cab",
      "description": "Reliable and affordable cab services from Pune to Gokarna, perfect for leisure travelers and tourists exploring the scenic coastal town."
    },
    {
      "name": "Pune to Outstation Taxi",
      "description": "Professional taxi services from Pune for all outstation destinations, providing comfort, safety, and timely service for your travel needs."
    }
  ],
  "tableData": [
    ["Pune Outstation Cab Services", "Pune Outstation Taxi Booking"],
    ["Pune Outstation Car Rental", "Pune Outstation Chauffeur-Driven Cabs"],
    ["Pune Outstation One-Way Taxi", "Pune Outstation Round Trip Cabs"],
    ["Pune Outstation Luxury Taxi", "Pune Outstation Self-Drive Car Rental"],
    ["Pune Outstation Travel Packages", "Pune Outstation Private Car Hire"],
    ["Pune Outstation Cabs", "Outstation Taxi Service Pune"],
    ["One Way Cab Pune", "Best Outstation Cab Service in Pune"],
    ["Outstation Cab Service in Pune", "Outstation Car Rental Pune"],
    ["Taxi in Pune for Outstation", "Taxi Service in Pune for Outstation"],
    ["Book Outstation Cabs Pune", "Cab Booking in Pune for Outstation"],
    ["Outstation Taxi in Pune", "Outstation Taxi Service in Pune"],
    ["Pune Airport to Kolhapur cab", "Pune Car Rental Outstation"],
    ["Pune to Gokarna Cab", "Pune to Outstation Taxi"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune Outstation Cabs for Comfortable Travel",
        "WhyChoosedescription": "Platinum24 Cabs provides cost-effective and reliable outstation cab services from Pune to various destinations."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Long-Distance Trips",
        "WhyChoosedescription": "Our well-maintained cabs offer ample legroom and comfort, perfect for your outstation journeys."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We ensure all vehicles are thoroughly cleaned and sanitized before every trip to maintain hygiene and safety."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our professional drivers are familiar with popular outstation routes from Pune to ensure smooth and timely travel."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Match Your Itinerary",
        "WhyChoosedescription": "Whether you need one-way, round-trip, or multi-day rentals, we customize packages to suit your travel plans."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for complete peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Group Tours, Pilgrimages, and Corporate Trips",
        "WhyChoosedescription": "Our Pune outstation cabs cater to various group travel needs including religious tours, family trips, and business travel."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, itinerary changes, and special requests."
    }
]
















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer outstation cab services from Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable outstation cab services from Pune to various destinations.',
    },
    {
        question: 'How can I book outstation cabs from Pune with Platinum24 Cabs?',
        answer: 'You can easily book outstation cabs through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for outstation trips from Pune?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars to suit different group sizes and travel preferences.',
    },
    {
        question: 'Are the drivers experienced for long-distance outstation travel?',
        answer: 'Yes, all our drivers are professional, experienced, and familiar with long-distance routes starting from Pune.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for outstation cabs?',
        answer: 'Yes, you can specify multiple pickup and drop-off points as per your travel itinerary.',
    },
    {
        question: 'What is included in the fare for Pune outstation cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Are there flexible rental packages for outstation cab hires?',
        answer: 'Yes, we offer hourly, daily, and multi-day packages to accommodate your outstation travel needs.',
    },
    {
        question: 'What safety measures are taken for outstation cab services?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety protocols to ensure a safe and comfortable journey.',
    },
    {
        question: 'Can I hire outstation cabs for popular destinations from Pune?',
        answer: 'Yes, Platinum24 Cabs offers outstation cab services to popular destinations such as Mumbai, Nasik, Lonavala, Shirdi, and more.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate outstation travel services from Pune?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for outstation routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Deshpande',
        feedback: 'Platinum24 Cabs made my outstation trip from Pune seamless and comfortable. Highly recommended for long-distance travel!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Excellent service and professional drivers for Pune outstation cab bookings. I will definitely use Platinum24 Cabs again.',
        rating: 5,
    },
];
































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneOutstationCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Outstation Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-outstation-cabs.jpg",
  "description": "Book Pune Outstation cabs with Platinum24 Cabs for reliable one-way, round trip, luxury, and chauffeur-driven taxi services. Perfect for travel to Kolhapur, Gokarna, and other destinations with 24/7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.85",
    "ratingCount": "13500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1700",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-outstation-cabs"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune Outstation Cabs | One-Way & Round Trip Taxi Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune Outstation cabs with Platinum24 Cabs for reliable one-way, round trip, luxury, and chauffeur-driven taxi services. Perfect for travel to Kolhapur, Gokarna, and other destinations with 24/7 support."
  />
  <meta
    name="keywords"
    content="Pune Outstation Cab Services, Pune Outstation Taxi Booking, Pune Outstation Car Rental, Pune Outstation Chauffeur-Driven Cabs, Pune Outstation One-Way Taxi, Pune Outstation Round Trip Cabs, Pune Outstation Luxury Taxi, Pune Outstation Self-Drive Car Rental, Pune Outstation Travel Packages, Pune Outstation Private Car Hire, Pune Outstation Cabs, Outstation Taxi Service Pune, One Way Cab Pune, Best Outstation Cab Service in Pune, Outstation Cab Service in Pune, Outstation Car Rental Pune, Taxi in Pune for Outstation, Taxi Service in Pune for Outstation, Book Outstation Cabs Pune, Cab Booking in Pune for Outstation, Outstation Taxi in Pune, Outstation Taxi Service in Pune, Pune Airport to Kolhapur cab, Pune Car Rental Outstation, Pune to Gokarna Cab, Pune to Outstation Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneOutstationCabsSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneoutstationcabs;